import React, { useState } from 'react';
import {
    Box,
    Container,
    Typography,
    Card,
    Stack,
    TextField,
    Button,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    CircularProgress, // Yükleme göstergesi için eklendi
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify'; // Bildirimler için eklendi
import Services from 'src/services/Services'; // Servis dosyanız eklendi

export default function BoxOperationsSendingSMS() {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');
    
    // --- YENİ: Modallar ve yükleme durumu için state'ler ---
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [loading, setLoading] = useState(false); // API isteği için loading state'i

    const handleOpenConfirmModal = () => {
        if (phoneNumber && message) {
            setConfirmModalOpen(true);
        } else {
            toast.warn("Lütfen telefon numarası ve mesaj alanlarını doldurun.");
        }
    };
    
    const handleCloseConfirmModal = () => {
        if (!loading) { // Sadece yükleme yokken kapat
            setConfirmModalOpen(false);
        }
    };

    // --- GÜNCELLENDİ: Servis entegrasyonu yapıldı ---
    const handleConfirmSend = async () => {
        setLoading(true);
        try {
            await Services.BoxOperationSendingSMS(phoneNumber, message);
            
            // Başarılı durumda yapılacaklar
            toast.success("Mesaj başarıyla gönderildi!");
            setPhoneNumber('');
            setMessage('');
            setConfirmModalOpen(false);
            setSuccessModalOpen(true);

        } catch (error) {
            console.error("SMS gönderme hatası:", error);
            toast.error("Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.");
            setConfirmModalOpen(false); // Hata durumunda onay modalını kapat
        } finally {
            setLoading(false);
        }
    };

    const handleCloseSuccessModal = () => {
        setSuccessModalOpen(false);
    };

    return (
        <Container sx={{ mt: 2, mb: 4, maxWidth: '920px', mx: 0 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="p" fontWeight="bold">
                    SMS Gönderme
                </Typography>
            </Stack>

            <Card sx={{ boxShadow: 'none', border: '1px solid #EAECF0', p: 3 }}>
                <Stack spacing={3} mt={2}>
                    <TextField
                        type='tel'
                        label="GSM Numarası"
                        placeholder="+90 (555) 000-0000"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        disabled={loading} // Yükleme sırasında devre dışı bırak
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' }, maxWidth: '400px' }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PhoneIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        label="Mesaj"
                        placeholder="Müşteriye gönderilecek mesajınız..."
                        multiline
                        rows={6}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        disabled={loading} // Yükleme sırasında devre dışı bırak
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    />
                    
                    <Button 
                        variant="contained"  
                        onClick={handleOpenConfirmModal}
                        disabled={!phoneNumber || !message || loading} // Yükleme sırasında devre dışı bırak
                        sx={{
                            backgroundColor: '#D92D20', color: '#FFFFFF', '&:hover': { backgroundColor: '#B42318' },
                            borderRadius: '8px', textTransform: 'none', px: 3, py: 1, alignSelf: 'flex-start'
                        }}
                    >
                        {loading ? 'Gönderiliyor...' : 'Mesajı Gönder'}
                    </Button>
                </Stack>
            </Card>

            {/* --- SMS Onay Modalı --- */}
            <Dialog open={confirmModalOpen} onClose={handleCloseConfirmModal} PaperProps={{ sx: { borderRadius: '12px', width: 400, p: 2 } }}>
                <DialogTitle sx={{ p: 2, }}>
                    <Typography variant="p" fontWeight={600}>SMS Gönderme Onayı</Typography>
                </DialogTitle>
                <DialogContent sx={{ p: 2,}}>
                    <Typography>
                        <Typography component="span" fontWeight="bold">{phoneNumber}</Typography> numaralı müşteri numarasına mesajınızı iletme işleminizi <Typography component="span" fontWeight="bold">onaylıyor musunuz?</Typography>
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2, pt: 1 }}>
                    <Stack spacing={1.5} width="100%">
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleConfirmSend}
                            disabled={loading} // --- GÜNCELLENDİ ---
                            sx={{ backgroundColor: '#D92D20', '&:hover': { backgroundColor: '#B42318' }, borderRadius: '8px', textTransform: 'none', py: 1 }}
                        >
                            {loading ? <CircularProgress size={24} color="inherit" /> : 'Gönder'}
                        </Button>
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={handleCloseConfirmModal}
                            disabled={loading} // --- GÜNCELLENDİ ---
                            sx={{ color: '#344054', borderColor: '#D0D5DD', '&:hover': { borderColor: '#B4BCCB' }, borderRadius: '8px', textTransform: 'none', py: 1 }}
                        >
                            İptal
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>

            {/* --- Başarı Modalı --- */}
            <Dialog open={successModalOpen} onClose={handleCloseSuccessModal} PaperProps={{ sx: { borderRadius: '12px', maxWidth: 420, width: '100%' } }}>
                <IconButton onClick={handleCloseSuccessModal} sx={{ position: 'absolute', right: 8, top: 8 }}><CloseIcon /></IconButton>
                <DialogContent sx={{ p: 4 }}>
                    <Stack alignItems="center" spacing={2} textAlign="center">
                        <Stack backgroundColor="#209F63" width={60} height={60} borderRadius={'50%'} alignItems={'center'} justifyContent="center">
                            <CheckIcon sx={{ fontSize: 36, color: '#FFF' }} />
                        </Stack>                        
                        <Typography variant="p" fontWeight={600}>
                            Mesajınız karşı tarafa başarıyla iletilmiştir.
                        </Typography>
                    </Stack>
                </DialogContent>
            </Dialog>
        </Container>
    );
}